<template>
  <div class="login">
    <div>
      <h1>Fantasyroom</h1>
      <span>Reklamationsverwaltung</span>
    </div>
    <form @submit.prevent="handleSubmit">
      <InputText
        @keyup.enter="handleSubmit"
        id="login.email"
        type="email"
        v-model="email"
        placeholder="E-Mail Adresse"
        name="email"
      />
      <InputText
        @keyup.enter="handleSubmit"
        id="login.password"
        type="password"
        v-model="password"
        placeholder="Passwort"
        name="password"
      />
      <Button
        @keyup.enter="handleSubmit"
        label="In der Reklamationsverwaltung Anmelden"
        severity="primary"
        @click="handleSubmit"
        raised
      />
    </form>
  </div>
</template>

<script>
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { useRouter } from 'vue-router'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import { FirebaseError } from 'firebase/app'

export default {
  components: {
    Button,
    InputText
  },

  data() {
    return {
      email: '',
      password: '',
      auth: getAuth(),
      router: useRouter()
    }
  },

  methods: {
    async handleSubmit() {
      try {
        if (!this.email || !this.password) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Bitte fülle alle Felder aus.',
            group: "tc",
            life: 3000
          })
          return;
        }

        await signInWithEmailAndPassword(
          this.auth,
          this.email,
          this.password
        )
        this.router.push('/')
        location.reload();
      } catch (e) {
        if (e instanceof FirebaseError) {
          switch (e.code) {
            case 'auth/invalid-credential':
            case 'auth/wrong-password':
            case 'auth/user-not-found':
              this.$toast.add({
                severity: 'error',
                summary: 'Anmeldung fehlgeschlagen',
                group: "tc",
                detail: 'Die E-Mail Adresse und das Passwort stimmen nicht überein.',
                life: 5000
              })
              break;
            case 'auth/invalid-email':
              this.$toast.add({
                severity: 'error',
                summary: 'Ungültige E-Mail Adresse',
                group: "tc",
                detail: 'Bitte gib eine gültige E-Mail Adresse ein.',
                life: 5000
              })
              break;
            case 'auth/missing-password':
              this.$toast.add({
                severity: 'error',
                summary: 'Passwort fehlt',
                group: "tc",
                detail: 'Bitte gib ein Passwort ein.',
                life: 5000
              })
              break;
            case 'auth/user-disabled':
              this.$toast.add({
                severity: 'error',
                summary: 'Benutzer deaktiviert',
                group: "tc",
                detail: 'Dieser Benutzer ist deaktiviert.',
                life: 5000
              })
              break;
            default:
              this.$toast.add({
                severity: 'error',
                summary: 'Fehler',
                group: "bc",
                detail: 'Es ist ein unbekannter Fehler aufgetreten.',
                life: 5000
              })
              break;
          }
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Anmeldung fehlgeschlagen',
            group: "bc",
            detail: 'Es ist ein Fehler aufgetreten.',
            life: 5000
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  background-color: var(--surface-0);
  border-radius: 0.75rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  box-shadow: 10px 10px 25px 10px #000000;
  text-align: center;
  padding: 1.2rem;

  div {
    display: flex;
    flex-direction: column;

    span {
      transform: translateY(-1.4rem);
    }
  }

  img {
    height: 4rem;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;

    Button {
      margin-top: 0.5rem;
    }
  }
}
</style>
